import React, { Component } from "react";
import { Link } from 'react-router-dom'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
//import { CSSTransition } from 'react-transition-group';
import { Button, PageHeader, Form, Col, PanelGroup, Panel } from "react-bootstrap";
import { getMeasureTitle }          from "../../utils/Measure";
import { getPercent1RM }            from "../../utils/OneRM";
import { ExerciseFreeFormId }       from "../../utils/StaticIds";
import { getExistingAthleteMetrics, begin1RMCalc, setNew1RM }from "../../utils/AthleteMetrics";
import uniqueId                     from "lodash/uniqueId";
import LoaderButton                 from "../../components/LoaderButton";
import StopWatch                    from "../../components/StopWatch";
//import YouTubeThumbnail             from "../../components/YouTubeThumbnail";
import YouTubePlayer                from "../../components/YouTubePlayer";
import PanelMeasureAddSubtract      from "../../components/PanelMeasureAddSubtract";
import SaveAllExerciseRow           from "../../components/workout/SaveAllExerciseRow";
import LinkHistory                  from "../../components/LinkHistory";
import ModalExerciseNotes           from "../../components/modal/ModalExerciseNotes";
import ModalExerciseAthleteNotes    from "../../components/modal/ModalExerciseAthleteNotes";
import WorkoutFinishedBox           from "../../components/workout/WorkoutFinishedBox";
import { AccountDemo }              from "../../utils/StaticIds";
import { WhiteLabel }               from "../../utils/WhiteLabelProps";

import { invokeGetWorkoutExerciseDetails,
         invokeSetAthleteExerciseMetrics,
         invokeSetAthleteExerciseMetricsSaveAll
       } from "../../utils/AwsInvoke";
import { Steps, Hints }             from "intro.js-react"; // js code for welcome tour

import "intro.js/introjs.css"; // css for welcome tour
import "../../css/workout/WorkoutDetail.css";
const uuidv4 = require('uuid/v4');

var white_label      = WhiteLabel();
const MainColor      = white_label.company_primary_btn_color;
const CloseBtnColor  = white_label.company_close_btn_color;
const SecondaryColor = white_label.company_primary_btn_color;

// Capture data in global vals for the "Save All" button;
// Can't add in SetState otherwise there's an endless loop
// Below is a temp solution, replace shortly
var save_all_metric_a_vals = []; // Weight: lbs/kg ; For Predictive Loading, replaces % of Max (id: 12)
var save_all_metric_b_vals = []; // Mainly used for REPS (row 2 from admin side)

var save_all_metric_a_ids = [];
var save_all_metric_b_ids = [];

var save_all_metric_psmv_ids      = [];
var save_all_metric_set_ids       = [];
var save_all_metric_set_numbers   = [];
var save_all_metric_exercise_ids  = [];
var track_measure_psmv_id_arr     = []; // track all psmv ids to track when a Set is completed

var workout_box_overlay = "none";

// Ensure all elements/values in an array is the same
// Used to ensure all reps are the same to calculate 1RM
const allEqual = arr => arr.every( v => v === arr[0] )

export default class WorkoutDetail extends Component {
    constructor(props) {
        super(props);

        var week_day = `${this.props.match.params.week_tracker}`;
        var week = week_day.substring(0, 1);
        var day = week_day.substring(2, 3);
        var curr_week_day = "Week " + week + ", Day " + day;

        this.state = {
            title:        `${this.props.match.params.title}`,    // init values
            program_id:   `${this.props.match.params.program_id}`,// init values
            day_id:       `${this.props.match.params.day_id}`,
            set_id:       `${this.props.match.params.set_id}`,    // init values
            block_id:     `${this.props.match.params.block_id}`,  // init values
            summary_id:   `${this.props.match.params.summary_id}`,// init values
            week_tracker:  curr_week_day,
            curr_week:     week,
            curr_day:      day,
            activeKey: 1,
            activeKeyArr: [],
            isLoading: true,
            new_metric_a_arr: 0,
            new_metric_b_arr: 0,
            day_block_ids: [],
            blocks_and_set_ids: [],
            compl_day_block_ids: [],
            highlightNextBtn: false,
            list: [],
            freeform_saved: false,
            initWorkoutDetailScreen: false,
            showModalExerciseNotes: false,
            showModalExerciseAthleteNotes: false,
            workoutFinished: false,
            pageOverlay: "none",
            tourFontColor: "#fff",

            // Help Tour //
            stepsEnabled: false,
            initialStep: 0,
            steps: [
                {
                  element: ".workoutDetailMyNotesProductTour",
                  intro: "Add personal exercise notes and review them at a later date.",
                  position: 'left'
              },
              {
                  element: ".workoutDetailHistoryProductTour",
                  intro: "See your exercise history and weekly personal bests.",
                  position: 'auto'
              },
              /*{
                  element: ".workoutDetailPanelSubtractProductTour",
                  intro: "SUBTRACT the measurable value by 1.",
                  position: 'auto'
              },
              {
                  element: ".workoutDetailPanelTextfieldProductTour",
                  intro: "Click INSIDE the input box and type in a value!",
                  position: 'auto'
              },
              {
                  element: ".workoutDetailPanelAddProductTour",
                  intro: "ADD the measurable value by 1.",
                  position: 'auto'
              },
              {
                  element: ".workoutDetailPanelSaveBtnProductTour",
                  intro: "Save the values above before moving onto the next exercise. Once you click this button, it will <b>automatically</b> take you to the next exercise.",
                  position: 'auto'
              },*/
              {
                  element: ".workoutDetailSaveAllProductTour",
                  intro: "Click and SAVE ALL the pre-populated exercise values at once.",
                  position: 'auto'
              },
              /*{
                  element: ".workoutDetailNextExercProductTour",
                  intro: "Go to the next exercise",
                  position: 'auto'
              }*/
            ],
        };
    }

    async componentDidMount() {
        if (!this.props.isAuthenticated)
            return;

        try {
            workout_box_overlay = "none"; // reset page overlay
            this.renderExerciseSetList();
            //this.props.showStopwatch(true); // show the stopwatch footer
        } catch (e) {
            alert(e);
        }

        this.setState({
            isLoading: false,
            //pageOverlay: "none"
        });
    }

    componentDidUpdate () {
        //console.log("componentDidUpdate!!!!!!!!!");
    }

    async renderExerciseSetList() {

        ////  If user is viewing the workout details page and stays on the page for 8+ hours, the page will kick them
        ////  back to the previous page so the location.state.ids will be reloaded; this is used for tracking all block ids
        ////  in the workout
        if(this.props.location.state.day_block_ids == undefined) this.handleGoBackPage();

        var user_id       = this.props.globalUserId;
        var program_id    = this.state.program_id;
        var set_id        = this.state.set_id;
        var block_id      = this.state.block_id;
        var day_block_ids      = this.props.location.state.day_block_ids;
        var blocks_and_set_ids = this.props.location.state.blocks_and_set_ids;
        var results;

        var b_ctr = 1;
        var current_exercise_number = 0;
        ////  Calculate the current exercise order & total exercises  ////
        for(var i=0; i < blocks_and_set_ids.length; i++) {

            var tmp_block_id = blocks_and_set_ids[i][0];
            var tmp_set_id = blocks_and_set_ids[i][1];
            if(tmp_block_id === block_id) {
                if(set_id == tmp_set_id)
                    current_exercise_number = b_ctr;

                b_ctr++
            }

        }

        //console.log("exercise_order: " + exercise_order);

        if(!this.state.initWorkoutDetailScreen) {
            //console.log("***   renderExerciseSetList   ***");

            results  = await invokeGetWorkoutExerciseDetails(user_id, program_id, block_id, set_id, day_block_ids);

                /*var exercise_id = this.props.exercise_id;
                console.log("exercise_id: " + exercise_id);
                var results2     = await invokeGetAthleteNotes(exercise_id);
                console.log("results2: " + results2.status);*/

            if(results.status) {
                var list            = results.data.set_details;
                var athlete_metrics = results.data.athlete_metrics;
                var active_key      = this.getLastCompletedSection(list, athlete_metrics);
                var exercise_id     = results.data.exercise_details[0].exercise_id;

                if(results.data.oneRM == undefined) results.data.oneRM = 0;
                var exercise_one_rm  = results.data.oneRM;
                //var free_form_notes  = results.data.exercise_details.notes; // for FreeForm exercises
                var prev_set_id      = results.data.prev_exercise_id;
                var next_set_id      = results.data.next_exercise_id;
                var exercise_name    = results.data.exercise_details[0].name;
                var notes            = results.data.exercise_notes;
                var compl_day_block_ids = results.data.compl_day_block_ids;
                var day_completed       = results.data.day_completed;

                workout_box_overlay     = "none";

                this.setState({
                    user_id:         user_id,
                    list:            list,
                    exercise_name:   exercise_name,
                    exercise_notes:  notes,
                    summary:         results.data.exercise_details,
                    exercise_id:     exercise_id,
                    //free_form_notes: free_form_notes,
                    yt_id:           results.data.exercise_details[0].youtube_id,
                    athlete_metrics: athlete_metrics,
                    perm_athlete_metrics: athlete_metrics,
                    exercise_1rm:    exercise_one_rm,
                    activeKey:       active_key,
                    prev_set_id:     prev_set_id,
                    next_set_id:     next_set_id,
                    day_block_ids:       day_block_ids,
                    blocks_and_set_ids:  blocks_and_set_ids,
                    compl_day_block_ids: compl_day_block_ids,
                    day_completed:       day_completed,
                    currentExerciseNumber: current_exercise_number,
                    totalExercises:        b_ctr-1,
                    pageOverlay: "none",
                    initWorkoutDetailScreen: true
                })
            }
        }
    }

    getLastCompletedSection (list, athlete_metrics) {
        var total_sets      = list.length/4;
        var set_lgth          = total_sets+1;
        var curr_active_key = 1;
        var ctr             = 0;
        var measure_2_psmv_ids   = [];

        // Loop through list of all Athlete Exercise Metrics
        for(var key in list) {
            var list2 = list[key];

            // Multiply by 2 since we are using the second metric
            if(ctr >= total_sets && ctr < total_sets*2)
                measure_2_psmv_ids.push(list2.psmv_uid);

            ctr++;
        }

        for(var i = 0; i < set_lgth; i++) {
            var measure_psmv_id = measure_2_psmv_ids[i];

            //// Check If There's a Matching Metric ID, if there is, display it ////
            var athlete_data = getExistingAthleteMetrics(measure_psmv_id, athlete_metrics);
            var obj_lgth     = Object.keys(athlete_data).length;

            // IF Obj Lgth is above 0, then there's a Match! //
            if(obj_lgth > 0) {
                    var measure_a = parseInt(athlete_data.metric_a);
                    curr_active_key = i+2; // +1 = Starting Set element; +2 = Go to next Set that is not completed
            }
        }

        return curr_active_key;
    }

    saveSingleSetMetricData = async (set_id, exercise_id, set_number, measure_id, metric_a, metric_b, metric_a_id, metric_b_id, psmv_id, panel_group_ctr, block_id, callback) => {
        var summary_id     = this.state.summary_id;
        var active_key     = this.state.activeKey;
        var new_active_key = active_key + 1; // manually cloe and open next panel
        var new_key_arr    = this.state.activeKeyArr;
        var user_id        = this.state.user_id;
        var program_id     = this.state.program_id;
        var block_id       = this.state.block_id;
        var one_rep_max    = this.state.exercise_1rm
        var list           = this.state.list;
        var total_sets     = list.length/4;
        var set_completed  = false;
        var psmv_id_lgth   = 0;
        var total_psmvs    = 0;
        new_key_arr.push(active_key)

        //console.log("++++++++++  saveSingleSetMetricData  ++++++++++");

        var psmv_exists = track_measure_psmv_id_arr.indexOf(psmv_id);

        ////////////////////////////////////////////////////////
        ////   Check if all Sets in a block are completed   ////
        ////   Does psmv id exist? If not, add the id to the total length and if it
        ////   equals total sets, then this set is complete
        if(psmv_exists == -1) {
            psmv_id_lgth = track_measure_psmv_id_arr.length;
            total_psmvs = psmv_id_lgth + 1;
        } else {
            ////  If the psmv id exists, use the current array length to get total number of completed exercise sets (psmvs)
            total_psmvs = track_measure_psmv_id_arr.length;
        }

        if(parseInt(total_psmvs) >= parseInt(total_sets)) {
            //console.log(" !!!!!!!!!!!!!!!  EXERCISE COMPLETED !!!!!!!!!!!!!!!");
            set_completed = true;
        }

        ////// GET New 1RM Value ////
        var obj1RM   = begin1RMCalc(one_rep_max, metric_a_id, metric_b_id,  metric_a, metric_b);
        var calc_1rm = obj1RM.calc_1rm;
        var one_rm   = obj1RM.one_rm;
        var screen   = "workoutDetail";
        ////  One RM MUST be higher than one_rep_max in order to be used, otherwise there's a lower value for 1RM for the same exercise during the same day  ////
        ////  Note: removed  'one_rm != one_rep_max' on 5/30/19
        if(calc_1rm && (parseInt(one_rm) > parseInt(one_rep_max))) {
                one_rep_max = one_rm;
                this.setState({exercise_1rm: one_rep_max})
        }

        this.setState({
            pageOverlay: "inline"
        })

        var results = await invokeSetAthleteExerciseMetrics(screen, user_id, program_id, block_id, set_number, set_id, exercise_id, psmv_id, metric_a, metric_b, metric_a_id, metric_b_id, one_rep_max, set_completed);

        if(results.status) {
            this.renderExerciseSetList(); // this resets predictive loading data; // refresh exercise list and check if a Set is "checked off or on"

            var free_form = false;
            if(exercise_id === ExerciseFreeFormId) free_form = true
            workout_box_overlay = "none";


            this.setState({
                //pageOverlay: "none",
                //highlightNextBtn: true,
                activeKey: new_active_key, // manually cloe and open next panel
                activeKeyArr: new_key_arr, // track the active keys for adding a green checkmark
                initWorkoutDetailScreen: true, // after initial load of screen, set this flag
                freeform_saved: free_form
            }, function () {
                // Free-form uses a callback to close the free-form scren and go b  ack
                if(callback != undefined) {
                    // Go back in history for Free-form callback
                    callback();
                } else {
                    // After saving an exercise, go to next Exercise
                    this.handleNextExercise();
                }
            })
        }
    }

    renderProgramsList(summary) {

        if(summary != undefined) {
            var exercise_id = summary[0].exercise_id;
            var name     = summary[0].name;
            var start    = summary[0].start;
            var focus    = summary[0].focus;
            var execute  = summary[0].execute;
            var goal     = summary[0].goal;
            var notes    = summary[0].notes;

            var exercise_data = this.renderBodyText(exercise_id, name, start, focus, execute, goal, notes);

            var programs = <span className="workoutDetailsContainer" >
                                    { /*<span className="programSummaryImage">
                                        <img src={require('../images/program_categories/abs.jpg')} width="400"/>
                                        </span>
                                    { /*}<span className="programWorkoutFadeImage">
                                        <img src={require('../images/utils/program_category_black_fade2.png')} height="105"/>
                                        </span> */ }

                                    <span className="">
                                         { exercise_data }
                                    </span>
                                    <StopWatch displayStopwatch={true} />
                            </span>
        }

        return programs;
    }

    handleGenericClick = event => {
        event.preventDefault();
        // do we need this?
        this.props.history.push(event.currentTarget.getAttribute("href"));
    }

    renderLander() {
        return (
            <div className="lander">
                <h1>TS</h1>
            </div>
        );
    }

    handleSelect (activeKey) {
        this.setState({ activeKey });
    }

    createMarkup(text) { return {__html: text}; };

    renderList() {
        return (
            <div className="list">
                {!this.state.isLoading && this.renderProgramsList(this.state.summary)}
            </div>
        );
    }

    getExercises (set_id, exercise_id, ctr, measure_id, measure_a, measure_b, measure_c, measure_rest, psmv_id, measure_2_id, measure_3_id, measure_2_title, measure_3_title, athlete_id) {
            var yt_id   = "";
            var rest    = 30;//set_key.rest;

            var day_block_ids           = this.props.location.state.day_block_ids;
            var curr_block_id           = this.state.block_id;
            var block_order             = day_block_ids.indexOf(curr_block_id);
            var current_exercise_number = this.state.currentExerciseNumber;
            var total_exercises         = this.state.totalExercises;
            var panel_height            = 302;

            return ( <Panel.Body collapsible key={uniqueId()} className="workoutDetailsBodyPanel">
                            <div className="workoutDetailsAccordionPanel" style={{height: panel_height}}>
                                <PanelMeasureAddSubtract saveSingleSetMetricData = {this.saveSingleSetMetricData}
                                                         set_id          = { set_id }
                                                         block_id        = { "none" }
                                                         exercise_id     = { exercise_id }
                                                         panel_ctr       = { ctr }
                                                         measure_id      = { measure_id }
                                                         measure_a_value = { measure_a }
                                                         measure_b_value = { measure_b }
                                                         measure_c_value = { measure_c } /* % of max note to left of Save btn */
                                                         measure_rest    = { measure_rest }
                                                         psmv_id         = { psmv_id }
                                                         measure_a_id    = { measure_2_id } /* measure 1 is static: Set*/
                                                         measure_b_id    = { measure_3_id }
                                                         measure_2_title = { measure_2_title }
                                                         measure_3_title = { measure_3_title }
                                                         panel_group_ctr = { 0 }
                                                         athlete_id      = { athlete_id }

                                                         blockNumber     = {block_order+1}
                                                         exerciseNumber  = {current_exercise_number}
                                                         exercisesTotal  = {total_exercises}
                                                         changeMetricValue = { this.changeMetricValue } />
                            </div>
                    </Panel.Body>
            )
        }

    handleCompleteCheckmark = event => {
        event.preventDefault();
    }

    getSeconds(mmss) {
        var a = mmss.split(':'); // split it at the colons
        //console.log("mmss: " + mmss);
        //console.log("split: " + a);
        var seconds = ((a[0]) * 60 + (+a[1]));

        //console.log("Total secs: " + seconds);
        return seconds;
    }


     convertMMSS (totalSeconds) {
          var hours   = Math.floor(totalSeconds / 3600);
          var minutes = Math.floor((totalSeconds - (hours * 3600)) / 60);
          var seconds = totalSeconds - (hours * 3600) - (minutes * 60);

          // round seconds
          seconds = Math.round(seconds * 100) / 100

          /* incl hours
              var result = (hours < 10 ? "0" + hours : hours);
              result += ":" + (minutes < 10 ? "0" + minutes : minutes);
              result += ":" + (seconds  < 10 ? "0" + seconds : seconds);*/
              var result = (minutes < 10 ? "0" + minutes : minutes);
                  result += ":" + (seconds  < 10 ? "0" + seconds : seconds);
          return result;
    }

    getObjectSize = (obj) => {
        var size = 0, key;
        for (key in obj) {
            if (obj.hasOwnProperty(key)) size++;
        }
        return size;
    }

    convertTimeMMSS(val) {
        var tmp_measure_a = val;
        //var hms = '02:04:33';   // your input string
        var a = tmp_measure_a.split(':'); // split it at the colons

        //console.log("a0: " + a[0]);
        //console.log("a1: " + a[1]);
        // minutes are worth 60 seconds. Hours are worth 60 minutes.
        var measure_a = (Number(a[0]) * 60) + Number(a[1]);
        //console.log("measure_a: " + measure_a);

        return measure_a;
    }

    renderSetList(athlete_id) {
        //console.log("++++++++ renderSetList");
        var programs = [];
        var list   = this.state.list;
        var blocks = "";//this.state.block_ids;

        var total_sets = list.length/4; // 4 = total number of measurements, ie sets/reps/% of max/rest
        var ctr = 0;
        var measure_1     = []; // # of sets
        var measure_2     = [];
        var measure_2_psmv_ids = []; // rep ids
        var measure_3_psmv_ids = []; // or rep ids
        var measure_2_id;
        var measure_3    = [];
        var measure_3_id;
        var measure_rest     = []; // always REST
        var measure_psm_ids      = [];
        // Clear vars
        save_all_metric_a_vals = []; // Weight: lbs/kg ; For Predictive Loading, replaces % of Max (id: 12)
        save_all_metric_b_vals = []; // Mainly used for REPS (row 2 from admin side)

        save_all_metric_a_ids        = [];
        save_all_metric_b_ids        = [];
        save_all_metric_psmv_ids     = [];
        save_all_metric_set_ids      = [];
        save_all_metric_set_numbers  = [];
        save_all_metric_exercise_ids = [];
        track_measure_psmv_id_arr    = []; // reset and track when a block is finished

        //console.log("============  BEGIN ROW DATA  ===========");

        for(var key in list) {
                // props: uid, measure_id, m_order, val, psmv_uid
                //console.log(key + ". list[key]: " + list[key].val);
                var list2      = list[key];
                var val        = list2.val;
                var measure_id = list2.measure_id;
                var psm_id     = list2.uid; // uid from program_set_measure table
                var psmv_uid   = list2.psmv_uid;

                if(ctr < total_sets) {
                    //console.log("------------ psm_id: " + psm_id);
                    //// Static SET Information ONLY ////
                    measure_1.push(val)
                    //console.log("Measure 1 val: " + val);
                } else if(ctr < total_sets*2){

                    measure_2.push(val);
                    measure_2_psmv_ids.push(psmv_uid);
                    measure_2_id = measure_id;
                    /*console.log("measure 2 psmv_uid: " + psmv_uid);
                    console.log("measure_2_id: " + measure_2_id);
                    console.log("Measure 2 val: " + val);*/
                } else if(ctr < total_sets*3){
                    //console.log("Measure 3 val: " + val);
                    measure_3.push(val)
                    measure_3_psmv_ids.push(psmv_uid);
                    measure_3_id = measure_id;
                    /*console.log("measure 3 psmv_uid: " + psmv_uid);
                    console.log("measure_3_id: " + measure_3_id);
                    console.log("Measure 3 val: " + val);*/
                } else if(ctr < total_sets*4){
                    //console.log("Measure 4 val: " + val);
                    // No need for measure id, Will ALWAYS BE REST
                    measure_rest.push(val)
                }
                measure_psm_ids.push(psm_id); //
                ctr++;
        }

        //console.log("============  END ROW DATA  ===========");
        //console.log("====== Predictive Loading =======");
        //console.log("measure_b: " + measure_b);
        //console.log("measure_c: " + measure_c);
        //console.log("measure_2_id: " + measure_2_id);
        //console.log("measure_3_id: " + measure_3_id);

        if(blocks != undefined) {
                var set_lgth               = total_sets+1;
                var set_id               = this.state.set_id;
                var exercise_id          = this.state.exercise_id
                var current_metrics      = this.state.athlete_metrics;
                var perm_athlete_metrics = this.state.perm_athlete_metrics;
                var one_rm               = this.state.exercise_1rm;
                var tmp_measure_a;
                var tmp_measure_b;
                var same_vals_arr = [];

                ////////////////////////////////////////////////////////////////
                ////    CHECK IF ALL FIELDS HAVE THE SAME SET # for 1RM     ////

                for(var h = 0; h < total_sets; h++) {

                    // Measure Ids:
                    // 2 = Reps
                    // 10 = Pounds
                    // 12 = Percent of Max (%)

                    //   Track if reps are consistent and all the same   ////
                    //  Below, in the if state., ALL repetitions are on the 2nd Row  //
                    if(measure_2_id == 2 && measure_3_id == 12 ||
                       measure_2_id == 10 && measure_3_id == 2 ||
                       measure_2_id == 5 && measure_3_id == 12 ||
                       measure_2_id == 10 && measure_3_id == 5)  {
                           var measure_psmv_id  = measure_2_psmv_ids[h];
                           var athlete_data     = getExistingAthleteMetrics(measure_psmv_id, current_metrics);
                           var measure_reps     = Number(measure_2[h]); //reps_val;
                           var obj_lgth         = Object.keys(athlete_data).length;

                           if(obj_lgth > 0) {
                                 measure_reps = Number(athlete_data.metric_b); // ie Reps     = id 2
                           } else {
                                 measure_reps        = Number(measure_2[h])
                                 //console.log("hit me.");
                           }

                           same_vals_arr.push(measure_reps)

                           //console.log("test: " + test);
                    } else if(measure_2_id == 2 && measure_3_id == 10 ||
                              measure_2_id == 12 && measure_3_id == 2 ||
                              measure_2_id == 5 && measure_3_id == 10 ||
                              measure_2_id == 12 && measure_3_id == 5)  {
                           var measure_psmv_id  = measure_3_psmv_ids[h];
                           var athlete_data     = getExistingAthleteMetrics(measure_psmv_id, current_metrics);
                           var measure_reps     = Number(measure_2[h]); //reps_val;
                           var obj_lgth         = Object.keys(athlete_data).length;

                           if(obj_lgth > 0) {
                                 measure_reps = Number(athlete_data.metric_b); // ie Reps     = id 2
                           } else {
                                 measure_reps = Number(measure_2[h])
                                 //console.log("hit me.");
                           }
                           //console.log("measure_reps: " + measure_reps);

                           same_vals_arr.push(measure_reps)
                    }
                }

                //////////////////////////////////////////////////////////////
                // The values above are different: measure_reps  AND test ... both values should be the same
                //////////////////////////////////////////////////////////////

                var all_same_reps = allEqual(same_vals_arr); // true | false

                for(var i = 1; i < set_lgth; i++) {
                        var i_ctr          = i-1;
                        var block_id       = ""; //blocks[i-1].block_id; // debugging purposes
                        var block_order    = ""; //blocks[i-1].block_order;
                        var measure_a      = ""; // weight: always 0 at the beginning of every new workout
                        var measure_b      = Number(measure_2[i_ctr]); //measure_b_value;
                        var measure_psmv_id= measure_2_psmv_ids[i_ctr];
                        var measure_c      = measure_3[i_ctr];
                        var measure_d_rest = measure_rest[i_ctr];
                        var measure_psm_id = measure_psm_ids[i_ctr*total_sets];
                        var cmark          = "checkmark_gray";
                        var bg_color       = "#f2f2f2";
                        /********************** BEGIN - Predictive Loading Measure ID Conversion Changes **********************/
                        var measure_2_title;
                        var measure_3_title;


                        /*console.log("--------------------------");
                        console.log("1. LBs measure_a: " + measure_a);
                        console.log("1. Reps measure_b: " + measure_b);
                        console.log("1. % max measur c: " + measure_c);*/

                        //// SHORTEN Certain Category Names ////
                        if(measure_2_id == 10) measure_2_title = "LBs";
                            else measure_2_title = getMeasureTitle(measure_2_id);

                        if(measure_3_id == 2) measure_3_title = "REPS";
                            else measure_3_title = getMeasureTitle(measure_3_id);

                        if(measure_2_id == 2 && measure_3_id == 12 ||
                           measure_2_id == 5 && measure_3_id == 12) { // } || measure_2_id == 10 && measure_3_id == 2)  {
                                // ID 2  = Reps
                                measure_2_title = "LBs";
                                // ID 12 = % of Max
                                measure_3_title = "REPS";

                                if(measure_2_id == 5) measure_3_title = "REPS PER SIDE";

                                /*
                                // For CLIENT SIDE Predictive Loading, multiply 1RM x (Max) Reps; ie 1RM*0.75  /
                                // If % of Max is selected on the Admin side, that will always be used in the calculation first;
                                var reps_val = measure_c; // measure c is % of max value
                                var percent  = "."+measure_c; //getPercent1RM(reps_val);
                                if(percent > ".100") percent = 1
                                // New Measure A value derived from Predictive Loading formula
                                measure_a = Math.round(one_rm * percent); // Rounds UP if .5+ or DOWN if .5-
                                */

                                // For CLIENT SIDE Predictive Loading, multiply 1RM x (Max) Reps; ie 1RM*0.75  /
                                // If % of Max is selected on the Admin side, that will always be used in the calculation first;

                                var reps_val      = measure_c; // measure c is % of max value
                                var percent       = "."+measure_c; //getPercent1RM(reps_val);
                                if(measure_c > 99) percent = measure_c/100; // in case % of max is > 100; ie 100% = 1 || 150% = 1.5

                                // New Measure A value derived from Predictive Loading formula
                                measure_a = Math.round(one_rm * percent); // Rounds UP if .5+ or DOWN if .5-

                        } else if(measure_2_id == 12 && measure_3_id == 2 ||
                                  measure_2_id == 12 && measure_3_id == 5) { // } || measure_2_id == 10 && measure_3_id == 2)  {

                                // ID 2  = Reps
                                measure_2_title = "REPS";
                                // ID 12 = % of Max
                                measure_3_title = "LBs";

                                if(measure_3_id == 5) measure_2_title = "REPS PER SIDE";

                                // For CLIENT SIDE Predictive Loading, multiply 1RM x (Max) Reps; ie 1RM*0.75  /
                                // If % of Max is selected on the Admin side, that will always be used in the calculation first;
                                var reps_val = measure_b; // measure c is % of max value
                                var percent  = "."+ measure_b;//getPercent1RM(reps_val);

                                measure_a = measure_c;
                                // New Measure A value derived from Predictive Loading formula
                                measure_b = Math.round(one_rm * percent); // Rounds UP if .5+ or DOWN if .5-
                        } else {
                            //console.log("Don't calc 1RM");
                            // Apply the different measures to new measure vars
                            measure_a = measure_b;
                            measure_b = measure_c;
                        }

                        /*console.log("-------");
                        console.log("2. LBs measure_a: " + measure_a);
                        console.log("2. Reps measure_b: " + measure_b);
                        console.log("2. % max measur c: " + measure_c);*/

                        //////////////////////////// PRE-EXISTING ATHLETE DATA /////////////////////////
                        ////    Check If There's a Matching Metric ID, if there is, display it      ////
                        var athlete_data      = getExistingAthleteMetrics(measure_psmv_id, current_metrics);
                        var athlete_perm_data = getExistingAthleteMetrics(measure_psmv_id, perm_athlete_metrics);
                        var obj_lgth          = Object.keys(athlete_data).length;
                        var obj_perm_lgth     = Object.keys(athlete_perm_data).length;

                        //// Measure Id 20: TIME (MM:SS) needs to be converted to seconds
                        if(measure_2_id === 20  || measure_2_id === 21) {
                            var val = measure_2[i_ctr];
                            var new_val = val.indexOf(":");

                            // if val = -1, No need to convert time since it is already in Seconds only
                            if(new_val == "-1") {
                                measure_a = parseInt(val);//this.convertTimeMMSS(val);
                            } else {
                                // Convert MM:SS into Seconds only
                                measure_a = this.convertTimeMMSS(val);
                            }

                            // Change TIME (MIN:SEC) category title to "Seconds"; this is a temp solution since we don't add seconds to the MM:SSS format yet //
                            measure_2_title = "Seconds";
                        }

                        //// Measure Id 21: SECONDS
                        if(measure_3_id === 20 || measure_3_id === 21) {
                            var val = measure_3[i_ctr];
                            var new_val = val.indexOf(":");

                            // if val = -1, No need to convert time since it is already in Seconds only
                            if(new_val == "-1") {
                                measure_b = parseInt(val);//this.convertTimeMMSS(val);
                            } else {
                                // Convert MM:SS into Seconds only
                                measure_b = this.convertTimeMMSS(val);
                            }

                            // Change TIME (MIN:SEC) category title to "Seconds"; this is a temp solution since we don't add seconds to the MM:SSS format yet //
                            measure_3_title = "Seconds";
                        }


                        // IF Obj Lgth is above 0, then there's a Match! //
                        // Replace new data with existing data           //
                        if(obj_lgth > 0) {
                            if(measure_2_id === 20)
                                measure_a = parseInt(athlete_data.metric_a); //this.convertTimeMMSS();
                            else {
                                measure_a = Number(athlete_data.metric_a); // ie Weight   = id 10
                                tmp_measure_a = measure_a;

                                var measure_b_tmp = Number(athlete_data.metric_b); // ie Weight   = id 10
                                tmp_measure_b = measure_b_tmp;
                            }

                            measure_b = Number(athlete_data.metric_b); // ie Reps     = id 2
                        }                                              // ie % of Max = id 12


                        // Requirements:
                        // 1. measure ids need to be Pounds/% of Max and Reps or vice-versa
                        // 2. All sets need to be the same set
                        // measure_2_id == 2 ||  measure_3_id == 2

                        // Measure Ids:
                        // 2 = Reps
                        // 10 = Pounds
                        // 12 = Percent of Max (%)

                        // Get One RM based on if Reps or Pounds comes first or second when calculating 1 Rep Max formulas

                        //if(measure_2_id != 20 && measure_2_id != 21 && tmp_measure_a > measure_a && all_same_reps) {

                        ////  If the previous set has a higher value than the current set, use the higher measure value  ////
                        //  Removes the ability to replace lower values with higher values
                        //  All sets that are the same (ie 5 sets, 5 sets, 5 sets) replace lower values with higher values
                        if(measure_2_id == 2 && measure_3_id == 10 && tmp_measure_a > measure_a && all_same_reps ||
                           measure_2_id == 5 && measure_3_id == 10 && tmp_measure_a > measure_a && all_same_reps) {
                            // Ie:  Lbs x Reps
                            measure_a = tmp_measure_a;
                        } else if(measure_2_id == 10 && measure_3_id == 2 && tmp_measure_b > measure_b && all_same_reps ||
                                  measure_2_id == 10 && measure_3_id == 5 && tmp_measure_b > measure_b && all_same_reps) {
                            // Ie:  12: % of Max x 2: Reps
                            measure_b = tmp_measure_b;
                        }

                        /*console.log("*** Get Exercises ***");
                        console.log("measure_a: " + measure_a);
                        console.log("measure_b: " + measure_b);
                        console.log("measure_c: " + measure_c);
                        console.log("--------------");*/

                        // IF Obj Lgth is above 0, then there's a Match! //
                        // Replace new data with existing data           //
                        var ak_arr = this.state.activeKeyArr;
                        var index_ak = ak_arr.indexOf(i);

                        if(obj_perm_lgth > 0 || index_ak != -1) {
                            track_measure_psmv_id_arr.push(measure_psmv_id);
                            // If there's existing data, mark it in the accordion view!
                            cmark = "checkmark_green";
                            bg_color = "#f1f1f1";
                        }

                        //// Used for the "Save All" function
                        save_all_metric_a_vals.push(measure_a);
                        save_all_metric_b_vals.push(measure_b);
                        save_all_metric_psmv_ids.push(measure_psmv_id);

                        // temp remove conversion:
                        // measure_d_rest = this.convertMMSS(measure_d_rest.toString());

                        //// IF IDs match "REPS" and "% of MAX", use the PREDICTIVE LOADING (PL) formula ////
                        //// With PL, DISPLAY "Weight LBs" & "Reps" in the Metrics Panel
                        //// and DO NOT DISPLAY ""% of Max", even though it's referenced as the measure 3 id

                        save_all_metric_a_ids.push(measure_2_id); // Save All btn functionality
                        save_all_metric_b_ids.push(measure_3_id);

                        var right_panel   = <span className="workoutDetailsPanelRight"
                                                  onClick={(e) => this.handleCompleteCheckmark(e)}>
                                                <img src={require('../../images/utils/'+cmark+'.png')} width="26"/>
                                            </span>

                        // Is demo account? If so, remove checkmark
                        if(AccountDemo === athlete_id) right_panel = <span style={{display:"inline-block", width: 46}}></span>

                        programs.push(  <Panel key = {i} eventKey={i} >
                                              <Panel.Heading style={{backgroundColor:bg_color, borderRight:4, borderLeft:"0px"}} >
                                                  <Panel.Title className="workoutDetailsTitle" toggle>
                                                        <span className="workoutDetailsPanelLeft">Set {i} {/*block_id*/}</span> { /* Set = measure_1_id, but we don't use it since it's static currently */ }
                                                        <span className="workoutDetailsPanelCenter">{measure_a} { measure_2_title } &nbsp;&nbsp;x &nbsp; {measure_b} {measure_3_title}</span>
                                                        { right_panel }
                                                  </Panel.Title>
                                              </Panel.Heading>
                                              { this.getExercises(set_id, exercise_id, i_ctr, measure_psm_id, measure_a, measure_b, measure_c, measure_d_rest, measure_psmv_id, measure_2_id, measure_3_id, measure_2_title, measure_3_title, athlete_id) }
                                        </Panel> )

                        save_all_metric_set_ids.push(set_id);
                        save_all_metric_set_numbers.push(i);
                        save_all_metric_exercise_ids.push(exercise_id);
                } // end for loop
        }

        var next_exerc_btn_color = MainColor;//"#666";
        if(this.state.highlightNextBtn) next_exerc_btn_color = SecondaryColor; //"#f5cf2f";

        var compl_day_block_ids = this.state.compl_day_block_ids;
        var curr_block_id       = this.state.block_id;
        var check_block_compl   = compl_day_block_ids.indexOf(curr_block_id);
        var block_finished      = false

        if(check_block_compl != -1) block_finished = true;

        var footer_buttons = <span className="workoutDetailSaveAllBtn" className="workoutDetailPrevExercBtn">
                                <span onClick={this.handlePrevExercise}>
                                    <LoaderButton
                                        height    = "38px"
                                        fontSize  = "17px"
                                        width     = "180px"
                                        btncolor  = "#ccc"
                                        isLoading = {this.state.isLoading}
                                        text      = "< PREVIOUS Exer"
                                        loadingText = ""
                                        type        = "submit"
                                      />
                              </span>
                              &nbsp; &nbsp;
                                <span onClick={this.handleNextExercise} className="workoutDetailNextExercBtn workoutDetailNextExercProductTour">
                                      <LoaderButton
                                          className = ""
                                          height    = "38px"
                                          fontSize  = "17px"
                                          width     = "180px"
                                          btncolor  = {next_exerc_btn_color}
                                          isLoading = {this.state.isLoading}
                                          text      = "NEXT Exer >"
                                          loadingText = ""
                                          type        = "submit"
                                        />
                                </span>
                           </span>
        if (this.state.workoutFinished) {
            workout_box_overlay = "inline";
            footer_buttons =  <div style={{position:"relative", marginLeft:"50%", left: -200}}>
                                    { /*}<WorkoutFinishedBox
                                        isLoading = {this.state.isLoading}
                                        handleWorkoutFinished = {this.handleWorkoutFinished}
                                    />*/ }
                              </div>
          } else if(block_finished) {

              footer_buttons =  <span className="workoutDetailNextBtn">
                                      <span onClick={this.handleNextBlock}>
                                            <LoaderButton
                                                height    = "38px"
                                                fontSize  = "17px"
                                                width     = "180px"
                                                btncolor  = {SecondaryColor}
                                                isLoading = {this.state.isLoading}
                                                text      = "NEXT BLOCK >"
                                                loadingText = ""
                                                type        = "submit"
                                              />
                                      </span>
                                 </span>
          }

        if(track_measure_psmv_id_arr.length >= set_lgth-1) {
            ////  Ensure the "Save All" checkmark is lit up green, even when the user doesn't click on it  ////
            ////  "block_finished" is also used when the "Save All" button is clicked
            block_finished = true;
        }

        var workout = <span style={{display: "inline-block", width: "100%"}}>
                            <div>
                                <PanelGroup accordion
                                            id="accordion"
                                            activeKey={this.state.activeKey  /*// activeKey removes the accordion animation */ }
                                            onSelect={this.handleSelect.bind(this)  /*}// onSelect removes the accordion animation */ }
                                            className="panel-group">
                                    { programs }
                                </PanelGroup>
                                <span className="workoutDetailsSaveAllExerciseRow">
                                    <SaveAllExerciseRow
                                        block_finished = {block_finished}
                                        athlete_id     = {athlete_id}
                                        handleSubmitCheckAll={this.handleSubmitCheckAll}
                                    />
                                </span>
                            </div>

                            { footer_buttons }
                      </span>

        return workout;
    }

    handleWorkoutFinished = event => {
      event.preventDefault();
      var title         = this.state.title;
      var week_tracker  = this.state.week_tracker;
      var program_id    = this.state.program_id;
      var day_id        = this.state.day_id;

      this.props.history.push(`/workoutFinished/${title}/${week_tracker}/${program_id}/${day_id}`);
  }

    handlePrevExercise = event => {
        var prev_set_id = this.state.prev_set_id;
        var block_id    = this.state.block_id;
        window.scrollTo(0,329);

        this.updateExercise(block_id, prev_set_id);
    }

    handleNextExercise = event => {
        var next_set_id = this.state.next_set_id;
        var block_id    = this.state.block_id;
        window.scrollTo(0,329);

        this.setState({
            highlightNextBtn: false,
        })

        this.updateExercise(block_id, next_set_id);
    }

    fadeOutNextExerciseText = () => {

    }

    handleNextBlock = event => {
        //console.log("========== handleNextBlock ============");
        var block_id           = this.state.block_id;
        var day_block_ids      = this.state.day_block_ids;
        var blocks_and_set_ids = this.state.blocks_and_set_ids; // all set ids and block ids

        /*for(var t=0; t < blocks_and_set_ids.length; t++) {
            console.log(t+". blocks_and_set_ids: " + blocks_and_set_ids[t]);
        }*/
        //// Get Next Block ID Element position
        var next_block_pos = day_block_ids.indexOf(block_id);
        var next_block_id  = day_block_ids[next_block_pos+1];
        var b_lgth         = blocks_and_set_ids.length;
        var next_set_id    = 0;

        // Ensure there is a next_block_id
        if(next_block_id != undefined) {
            ////  Find the first set id that matches the block id  ////
            for(var b=0; b < b_lgth; b++) {
                var tmp_block_id = blocks_and_set_ids[b][0]; // [0]: block id - [1]:  set id
                if(next_block_id === tmp_block_id) {
                    next_set_id = blocks_and_set_ids[b][1];
                    break;
                }
            }
        }

        var block_total_lgth = day_block_ids.length - 1; // deduct 1 because beg el starts @ 1
        if(next_block_pos >= block_total_lgth) {
            //console.log("The day workout is finished!!!");
            workout_box_overlay = "inline";

            this.setState({
                showWorkoutBox: "inline",
                workoutFinished: true
            })
        } else if(next_set_id != 0)
            this.updateExercise(next_block_id, next_set_id);
    }

    updateExercise = (block_id, goto_set_id) => {
        var title        = this.state.title;
        var program_id   = this.state.program_id;
        var day_id       = this.state.day_id;
        var week_tracker = this.state.week_tracker;

        this.setState({
            set_id: goto_set_id,
            block_id: block_id,
            activeKeyArr: [], // reset the active key
            initWorkoutDetailScreen: false
        }, function () {
            this.props.history.push({
                pathname: `/workoutDetail/${title}/${program_id}/${block_id}/${goto_set_id}/${day_id}/${week_tracker}`,
                state: {day_block_ids: this.state.day_block_ids, blocks_and_set_ids: this.state.blocks_and_set_ids}
            });
            this.renderExerciseSetList();
        })
    }

    handleGoBackPage = () => {
        this.props.history.goBack();
    }

    handleGoToDayView = () => {

        var title        = this.state.title;
        var program_id   = this.state.program_id;
        var day_id       = this.state.day_id;
        var curr_week    = this.state.curr_week;
        var curr_day     = this.state.curr_day;

        //// BEGIN: The actual marketplace_prog_id is not needed here
        //// because the id is only used when creating a new program day
        var mktplc_program_id = 0;
        this.props.history.push(`/programDayWorkout/${program_id}/${day_id}/${title}/${curr_week}-${curr_day}/${mktplc_program_id}`)
    }

    changeMetricValue = (panel_num, metric_a_val, metric_b_val, panel_group_ctr) => {
        // panel_group_ctr not used on this screen, but on other Exerc. Metrics Page

        /*var new_metric_a_arr = save_all_metric_a_vals;
        var new_metric_b_arr = save_all_metric_b_vals;

        if(this.state.new_metric_a_arr != 0) new_metric_a_arr = this.state.new_metric_a_arr;
        if(this.state.new_metric_b_arr != 0) new_metric_b_arr = this.state.new_metric_b_arr;

        if(metric_a_b === "metric_a") new_metric_a_arr.splice(panel_num, 1, val);
            else new_metric_b_arr.splice(panel_num, 1, val);

        /*this.setState({new_metric_a_arr: new_metric_a_arr, new_metric_b_arr: new_metric_b_arr}, function(){
            save_all_metric_a_vals = this.state.new_metric_a_arr;
            save_all_metric_b_vals = this.state.new_metric_b_arr;
        })*/

        var list = this.state.list;
        var ctr = 0;
        var mets_ctr = 0;

        var total_sets = list.length/4;
        var tmp_list   = [];
        var athlete_metrics = this.state.athlete_metrics;
        var exercise_1rm    = this.state.exercise_1rm;

        for(var key in list) {
                // Props: uid, val, measure_id, m_order, psmv_uid
                var list2      = list[key];
                var psm_id     = list2.uid; // uid from program_set_measure table
                var val        = list2.val;
                var measure_id = list2.measure_id;
                var m_order    = list2.m_order;
                var psmv_uid   = list2.psmv_uid;

                //// Edit and Rebuild list ////
                //// Get PSMV values
                if(ctr < total_sets*2){
                    //// PSMV values are only Valid in Section 2
                    var set = panel_num+total_sets;

                    if(set === ctr) {
                        var athl_mets = [];

                        // Check if the PSMV ID already exists
                        var exists = false;
                        //// Assign existing values to an object ////
                        for(var key in athlete_metrics) {
                            var tmp_psmv_id = athlete_metrics[key].psmv_id;
                            var tmp_metric_a_val = athlete_metrics[key].metric_a;
                            var tmp_metric_b_val = athlete_metrics[key].metric_b;
                            athl_mets[key] = {};
                            athl_mets[key].psmv_id  = tmp_psmv_id
                            athl_mets[key].metric_a = tmp_metric_a_val;
                            athl_mets[key].metric_b = tmp_metric_b_val;
                            if(psmv_uid === tmp_psmv_id) {
                                exists = true;
                                mets_ctr = key;
                            }
                        }

                        if(!exists) mets_ctr = athlete_metrics.length

                        //// Assign new values to an object ////
                        athl_mets[mets_ctr] = {};
                        athl_mets[mets_ctr].psmv_id  = psmv_uid
                        athl_mets[mets_ctr].metric_a = metric_a_val;
                        athl_mets[mets_ctr].metric_b = metric_b_val;
                    }
                }
                ctr++;
        }

        this.setState({
            athlete_metrics: athl_mets
        })
    }

    getUserId = () => {
        var globalUserId = localStorage.getItem('globalUserId');

        return globalUserId;
    }

    handleSubmitCheckAll = async event => {
        event.preventDefault();
        var user_id    = this.state.user_id;
        var program_id = this.state.program_id;
        var summary_id = this.state.summary_id;
        var set_id     = this.state.set_id;
        var block_id   = this.state.block_id;

        this.setState({
            pageOverlay: "inline"
        })

        //console.log("save_all_metric_set_ids: " + save_all_metric_set_ids);
        //// Capture All Data/Metrics for the "Save All" button ////
        //// Fields - metric_a, metric_b, metric_a_id, metric_b_id, psmv_id, set_id, exercise_id

        var results  = await invokeSetAthleteExerciseMetricsSaveAll(user_id, save_all_metric_set_numbers, save_all_metric_a_vals, save_all_metric_b_vals, save_all_metric_a_ids, save_all_metric_b_ids, save_all_metric_psmv_ids, save_all_metric_set_ids, save_all_metric_exercise_ids, program_id, block_id);

        if(results.status) {
            this.setState({ initWorkoutDetailScreen: false }, function () {
                this.handleNextExercise();
                //this.renderExerciseSetList();
            })
        } else
            this.setState({ pageOverlay: "none" })
    }

    renderExerciseBody = (start, focus, execute, goal) => {
        if(start === undefined   || start === null) start = "";
        if(focus === undefined   || focus === null) focus = "";
        if(execute === undefined || execute === null) execute = "";
        if(goal === undefined    || goal === null) goal = "";

        var start   = start.replace(/\\r\\n/g,' '); // removeall occurrences of \r\n
        var focus   = focus.replace(/\\r\\n/g,' ');
        var execute = execute.replace(/\\r\\n/g,' ');
        var goal    = goal.replace(/\\r\\n/g,' ');

        if(start != null && start != "") {
            start   = start.replace(/-\s/, "<li type='disc'>");
            start   = start.replace(/\s-\s/g, "</li><li  type='disc'>"); // replace space and hyphen
        } else start = "None.";
        if(focus != null && focus != "") {
            focus   = focus.replace(/-\s/g, "<li type='disc'>");
            focus   = focus.replace(/-\s/g, "</li><li  type='disc'>"); // replace space and hyphen
        } else focus = "None.";
        if(execute != null && execute != "") {
            execute = execute.replace(/-\s/g, "<li type='disc'>");
            execute = execute.replace(/-\s/g, "</li><li  type='disc'>"); // replace space and hyphen
        } else execute = "None.";
        if(goal != null && goal != "") {
            goal    = goal.replace(/-\s/g, "<li type='disc'>");
            goal    = goal.replace(/-\s/g, "</li><li  type='disc'>"); // replace space and hyphen
        } else goal = "None.";

        return <span>
                    <div className="workoutDetailsRow">
                        <br/>
                        <span className="workoutDetilsBodyPadding">
                        START
                        </span>
                       <span className="workoutDetailsSubRow">
                           <ol>
                               <div dangerouslySetInnerHTML={this.createMarkup(start)} />
                           </ol>
                       </span>
                    </div>
                    <div className="workoutDetailsRow">
                         <span className="workoutDetilsBodyPadding">
                         EXECUTE
                         </span>
                       <div className="workoutDetailsSubRow">
                           <ol>
                               <div dangerouslySetInnerHTML={this.createMarkup(execute)} />
                           </ol>
                       </div>
                    </div>
                    <div className="workoutDetailsRow">
                       <span className="workoutDetilsBodyPadding">
                        FOCUS
                       </span>
                       <div className="workoutDetailsSubRow">
                           <ol>
                               <div dangerouslySetInnerHTML={this.createMarkup(focus)} />
                           </ol>
                       </div>
                    </div>
                    <div className="workoutDetailsRow">
                        <span className="workoutDetilsBodyPadding">
                        GOAL
                       </span>
                       <div className="workoutDetailsSubRow">
                           <ol>
                               <div dangerouslySetInnerHTML={this.createMarkup(goal)} />
                           </ol>
                       </div>
                    </div>
            </span>
    }

    saveFreeFormData = (event, exercise_id) => {
            event.preventDefault();

            var measure_id  = 0; //this.state.measure_id;
            var metric_a    = 0;
            var metric_b    = 0;
            var metric_a_id = 0;
            var metric_b_id = 0;
            var set_number  = 0;
            var set_id      = this.state.set_id;
            var panel_group_ctr = null; // panel_group_ctr is used only in Exercise Metrics screen
            var block_id        = null;
            // PSMV UID can't be a randomly generated uuid since it needs to be referenced in the database (insert or update) in case the user
            // hit's the save button multiple times. Solution is to give any free-form exercise it's own unique id so it can be refereneced in
            // the PSM and PSMV DB tables; basically, treat the free-form exercise as if it were given ids like any other exercise in the advanced
            // Metrics Modal view
            var psmv_id     = uuidv4(); // this can be any uuid; it's required in the DB since there's a foreign key associated with it

            this.saveSingleSetMetricData(set_id, exercise_id, set_number, measure_id, metric_a, metric_b, metric_a_id, metric_b_id, psmv_id, panel_group_ctr, block_id, this.endFreeFormExercise);
    }

    endFreeFormExercise = () => {
        this.handleGoBackPage();
    }

    renderPlaceholderImage = (name) => {

        var cover_title  = this.state.title;
        var day_id       = this.state.day_id;
        var week_tracker = this.state.week_tracker;
        var program_id   = this.state.program_id;

        return  (<span>
                        <span className="programBeginImage">
                            <img src={require('../../images/program_categories/cardio1.jpg')} width="100%"/>
                        </span>
                        <span className="programWorkoutDetailFadeImage">
                            <img src={require('../../images/utils/program_category_black_fade3.png')} height="105" width="100%"/>
                        </span>
                        <span className="programWorkoutTitle"
                                  href={`/ProgramBegin/${program_id}/${cover_title}`}
                                  onClick={this.handleWorkoutDetails}
                                  style={{whiteSpace: "nowrap", overflowX:"hidden", color: "#fff"}}
                                  >
                                  {cover_title}
                        </span>
                        <span className="programWorkoutDateTitle"
                              style={{position:"absolute", top: 57, left:0, fontSize:"24px", color: "#fff"}}
                              >
                              {week_tracker}
                        </span>
                        {/*}<span className="programWorkoutFreeformTitle" style={{color:"black"}}></span>*/}
                        <span style={{display:"block",height:113}}/>
                 </span>)
    }

    renderBodyText(exercise_id, name, start, focus, execute, goal, free_form_notes) {
        var title         = this.state.title;
        var week_tracker  = this.state.week_tracker;
        var program_id    = this.state.program_id;
        var yt_id         = this.state.yt_id;
        var exercise_body;
        var button_text   = "Mark as Complete";
        var button_color  = MainColor;
        var athlete_id    = this.getUserId();
        var exercise_data = this.renderSetList(athlete_id); // accordion data
        var tour_font_color = this.state.tourFontColor;

        // need a blank image if there is no you tube id
        if(yt_id == "") yt_id = "empty_id";
        var my_notes        = <span className="workoutDetailsAthleteLabel workoutDetailMyNotesProductTour"
                                      onClick={this.handleShowAthleteNotes}>
                                      { /*}<FontAwesomeIcon icon="sticky-note" /> */}
                                      <span style={{color: tour_font_color}}>My Notes</span>
                                </span>

        var history         = <LinkHistory font_color         = {tour_font_color}
                                           handleGenericClick = {this.handleGenericClick}
                                           title        = {title}
                                           program_id   = {program_id}
                                           week_tracker = {week_tracker}
                                           exercise_id  = {exercise_id}
                                           yt_id        = {yt_id}
                              />
        var imageOrYouTube  = <YouTubePlayer yt_id={yt_id} />

        if(ExerciseFreeFormId === exercise_id) {
                if(this.state.freeform_saved) {
                    button_text  = "Free-form Completed";
                    button_color = MainColor; //"#5b9f38";
                }

                exercise_data = <div style={{paddingLeft:20}} dangerouslySetInnerHTML={this.createMarkup(free_form_notes)} />;
                exercise_body = <div onClick={(evt) => this.saveFreeFormData(evt, exercise_id)} className="workoutDetailSaveFreeFormBtn">
                                      <LoaderButton
                                          block
                                          height   = "40px"
                                          width    = "240px"
                                          fontSize = "17px"
                                          type     = "submit"
                                          btncolor = { button_color }
                                          isLoading= {this.state.isLoading}
                                          text     = { button_text }
                                          loadingText="Saving data…"
                                        />
                                </div> // there is no exercise body with Free Form exercises
                history       = ""; // there is no history with FreeForm

                //// FreeForm exercises use an image, not a YouTube video ////
                imageOrYouTube = this.renderPlaceholderImage("Free-Form Notes");

                // Clear new name var
                name = "";
        }

        // if no youtube video is avail. show an image
        if(yt_id === "empty_id") imageOrYouTube = this.renderPlaceholderImage(name);

        if(ExerciseFreeFormId != exercise_id)
           exercise_body = this.renderExerciseBody(start, focus, execute, goal);

        var exercise_notes = this.state.exercise_notes;
        var exercise_notes_icon;
        if(exercise_notes != undefined && exercise_notes != "") {
            exercise_notes_icon =   <FontAwesomeIcon icon="edit"
                                                     className="pull-right"
                                                     onClick={this.handleShowNotes}
                                                     style={{position:"relative", top:3, color: MainColor, fontSize: 24, cursor:"pointer"}}/>

        }
        var border_top = "5px solid " + CloseBtnColor;

        if(AccountDemo === athlete_id) {
            // reset the notes link since it's a demo acount
            my_notes = "";
        }

        return (
            <span className="workoutDetailsSummary">
                    { imageOrYouTube }
                    <div>
                        <div className="workoutDetailsHistoryRow" style={{borderTop: border_top }}>
                            <span className="workoutDetailsDayViewLabel"
                                  onClick={this.handleGoToDayView}>
                                <span className="goBackDayViewGlyphIcon">
                                    <span className="glyphicon glyphicon-menu-left"/>
                                </span>
                                Day View
                            </span>
                            { my_notes }
                            { history }
                        </div>
                        <span className="workoutDetilsBodyPadding">
                            <span className="workoutDetailsExerciseName">
                                { name }
                            </span>
                            <span style={{display:"inline-block", paddingLeft:7, fontSize: 21/*width: 40, backgroundColor:"transparent", border:"0px solid #000", position:"absolute", right:20*/}}>
                            { exercise_notes_icon }
                            </span>
                        </span>
                        { exercise_data }
                        { exercise_body }
                    </div>
            </span>
        );
    }

    handleShowNotes = () => {
        this.setState({ showModalExerciseNotes: true })
    }

    handleShowAthleteNotes = () => {
        this.setState({ showModalExerciseAthleteNotes: true })
    }

    workoutOverlay() {
        return <div style={{width:410, height: 228, borderRadius: 5, border:"2px solid #ccc", backgroundColor: "#666"}}>
                    <div style={{position:"relative", top:0}}>
                        <WorkoutFinishedBox
                              isLoading             = {this.state.isLoading}
                              handleHideOverlay     = {this.handleHideOverlay}
                              color                 = "white"
                              handleWorkoutFinished = {this.handleWorkoutFinished}
                        />
                    </div>
               </div>
    }

    handleHideOverlay = event => {
        workout_box_overlay = "none"

        this.setState({
            pageOverlay: "none",
            showWorkoutBox: "none",
            workoutFinished: false
        })
    }

    ////  Begin: Show Help Tour  ////
    onStart = () => {
        this.setState({ activeKey: 1 });
    };

    onExit = () => {
        this.setState(() => ({ stepsEnabled: false, tourFontColor: "#fff" }));
    };

    showHelpTour = () => {
        this.setState(() => ({ stepsEnabled: true, tourFontColor: "#000" }));
    }

    ////  End: Show Help Tour  ////

    render() {
        //console.log("DETAIL PAGE - workout_box_overlay: " + workout_box_overlay);
        //console.log("this.state.showWorkoutBox: " + this.state.showWorkoutBox);
        var exercise_id    = this.state.exercise_id;
        var exercise_name  = this.state.exercise_name;
        var exercise_notes = this.state.exercise_notes;
        let closeModalExerciseNotes        = () => this.setState({ showModalExerciseNotes: false }); //close simple modal window
        let closeModalExerciseAthleteNotes = () => this.setState({ showModalExerciseAthleteNotes: false }); //close simple modal window

        const {
            stepsEnabled,
            steps,
            initialStep,
        } = this.state;

        return (
              <div className="HomeProgramWorkoutDetails">
                  <span className = "workoutDetailMainIconHelpTour glyphicon glyphicon-question-sign"
                        onClick   = {this.showHelpTour}/>
                  { this.props.isAuthenticated ? this.renderList() : this.renderLander() }

                  {this.state.showModalExerciseAthleteNotes ?
                      <ModalExerciseAthleteNotes
                          show          = { this.state.showModalExerciseAthleteNotes}
                          onHide        = { closeModalExerciseAthleteNotes}
                          exercise_id   = { exercise_id }
                          exercise_name = { exercise_name }
                      />
                  : null}
                  {this.state.showModalExerciseNotes ?
                      <ModalExerciseNotes
                          show          = { this.state.showModalExerciseNotes}
                          onHide        = { closeModalExerciseNotes}
                          notes         = { exercise_notes }
                          exercise_name = { exercise_name }
                      />
                  : null}
                  <div>
                        <span className="pageOverlay" style={{display:this.state.pageOverlay}}></span>
                        <span style={{display: this.state.showWorkoutBox}}>
                            <span style={{float:"left", position:"fixed", top:"20%", marginLeft:"50%", left:-200, display: workout_box_overlay, zIndex:10000}}>
                                  { this.workoutOverlay() }
                            </span>
                        </span>
                  </div>

                  <Steps
                      enabled     = {stepsEnabled}
                      steps       = {steps}
                      initialStep = {initialStep}
                      onStart     = {this.onStart}
                      onExit      = {this.onExit}
                      options     = {{disableInteraction:true}}
                  />
              </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/screens/workout/WorkoutDetail.js